<style lang="scss" type="text/scss">
  .input {
  }

  .input-photo {
    margin-bottom: 16px;

    .input-photo-container {
      min-height: 300px;
      background: #f7f7f8;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .preview {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        z-index: 3;
        pointer-events: none;
        opacity: 0.7;
      }

      .button {
        border-radius: 12px;
        background: #fff;
        color: #424242;
        padding: 12px 16px;
        box-shadow: -1px 0 62px -6px rgba(0, 0, 0, 0.15);
        font-family: "Roboto", sans-serif;
        font-weight: 700;
        font-size: 13px;
        line-height: 21.034px;
        z-index: 99;
        position: relative;
      }

      input[type="file"] {
        appearance: none;
        background: #fff;
        display: none;
      }
    }
  }

  /*
      .doka--root {
        .doka--button-menu-cta {
          background-color: darken(#ff6452, 7);
          color: #fff;

          &:hover {
            background-color: #ff6452;
          }
        }
      }*/

  .input :global(.loader) {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 4;
  }
</style>

<script>
  import Loader from '../ui/loader';

  const Doka = window.Doka;

  export let value;
  export let label;
  export let options = {};
  export let readonly = false;
  
  let input;
  let loading = false;
  let preview = value;
  let doka;

  function click() {
    if (input) {
      input.click();
    }
  }

  function onFileChanged(e) {
    console.log('in file changed');
    var image = new FileReader();
    image.onload = () => {
      preview = image.result;
      doka = Doka.create({
        src: preview,
        onconfirm: onConfirm,
        oncancel: onCancel,
        ...options
      });      
    };
    
    image.readAsDataURL(e.target.files[0]);
  }

  async function upload(output) {
    loading = true;
    var formData = new FormData();
    formData.append('file', output);

    const response = await fetch(
      'https://honeycomb-event-api-staging.herokuapp.com/upload',
      {
        method: 'POST',
        body: formData
      }
    );
    const {location} = await response.json();
    preview = location;
    value = location;
    loading = false;
  }

  function onConfirm(output) {
    preview = null;
    upload(output.file);
  }

  function onCancel() {
    setPreview(null);
  }

  function onError(e) {
    console.log(e);
  }

</script>

<div class="input input-photo">
  {#if label} <label>{label}</label>{/if}
  <div class="input-photo-container">
    {#if loading}<Loader />{/if}
    <div class="preview" style={`background-image:url(${preview})`}></div>
    {#if !readonly}
    <input bind:this={input} on:change={onFileChanged} on:input={onFileChanged} type="file" />
    <div class="button" on:click={click}>
      Upload Photo
    </div>
    {/if}
  </div>
</div>